import { fetchApi } from '@/config/axiosSetting';
import {
  GetImagesTabsQueryParamsType,
  GetImagesTabsQueryResponseType,
} from '@/modules/adjusterReportModules/IncidentParticipants/queries/getCulpritImagesTabs/getImagesTabsQuery.type';

export const getImagesTabsFunction = (
  params: GetImagesTabsQueryParamsType,
): Promise<GetImagesTabsQueryResponseType> => {
  const url = () => {
    switch (params.userType) {
      case 'damaged':
        return `/property/reports/${params.id}/accident_users/damaged/images/entry_tabs/`;
      case 'culprit':
        return `/property/reports/${params.id}/accident_users/culprit/images/entry_tabs/`;

      default:
        return '';
    }
  };
  return fetchApi.get(url(), {
    params: { damaged_id: params.damaged_id ?? undefined },
  });
};
